import $ from 'jquery';
import { MetaRouter } from '../utils/metarouter';

export default ($el) => {
    const $subscriptions = $el.find('a.suggested__card');

    $subscriptions.on('click', (e) => {
        e.preventDefault();
        const $subscription = $(e.currentTarget);
        const subscriptionName = $subscription.find(
            '.suggested__card__title',
        )[0]?.innerText;
        const url = $subscription.attr('href');
        MetaRouter.sendTrackEvent('suggested_plan_selected', {
            screen_name: MetaRouter.getPageType(),
            chosen_theme: '',
            subscription_name: subscriptionName,
        });

        window.location.href = url;
    });
};
